import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

// Gets the filter labels in the order they should appear
const getDisplayProperties = (successCallback, errorCallback) =>
  UpdoxApi.getApi(
    'api/wait-list/properties',
    headers,
    successCallback,
    errorCallback,
  );

// perform a filter of the strategized filters
const filter = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    'api/wait-list/filter',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

// Request a waitlist with all the relevant data
const request = (data, successCallback, errorCallback) =>
  UpdoxApi.postApi(
    'api/wait-list/request',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );

const WaitlistApi = {
  filter,
  getDisplayProperties,
  request,
};

export default WaitlistApi;



// WEBPACK FOOTER //
// ./src/apis/waitlist.js